
/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ProjectAnalyticsRequest,
} from '../models';
import {
    ProjectAnalyticsRequestFromJSON,
    ProjectAnalyticsRequestToJSON,
} from '../models';

export interface ExportZipRequest {
    projectAnalyticsRequest: ProjectAnalyticsRequest;
}

/**
 * 
 */
export class ExportAnalyticsApi extends runtime.BaseAPI {

    /**
     * Export in zip format organization related analytics
          */
    async exportZipRaw(requestParameters: ExportZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['projectAnalyticsRequest'] == null) {
            throw new runtime.RequiredError(
                'projectAnalyticsRequest',
                'Required parameter "projectAnalyticsRequest" was null or undefined when calling exportZip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<Blob>({
            path: `/dashboard-client/api/analytics/export`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProjectAnalyticsRequestToJSON(requestParameters['projectAnalyticsRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Export in zip format organization related analytics
          */
    async exportZip(requestParameters: ExportZipRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.exportZipRaw(requestParameters, initOverrides);
        return response._data;
    }

}
